import { render, staticRenderFns } from "./InvoiceFlowTaskPage.vue?vue&type=template&id=7c5b5418&scoped=true&"
import script from "./InvoiceFlowTaskPage.vue?vue&type=script&lang=ts&"
export * from "./InvoiceFlowTaskPage.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceFlowTaskPage.vue?vue&type=style&index=0&id=7c5b5418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5b5418",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VDivider,VIcon,VRow,VSheet,VSpacer,VTab,VTabItem,VTabsItems,VTooltip})
